import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH PACKET PRODUCTS ********************
export const fetchPacketProducts = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PACKET_PRODUCTS_LOADING,
			payload: true
		});

		const { data } = await services.get(`/packet/${id}/products`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PACKET_PRODUCTS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PACKET_PRODUCTS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
